// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import type { Agent } from "node:http";
/**
 * @hidden
 */
export let defaultHttpAgent: Agent;
/**
 * @hidden
 */
export let defaultHttpsAgent: Agent;
